import React from "react";
import LocalizedShopifyProvider from "./LocalizedShopifyProvider";
import {cartQueryCustomFragment} from "./checkoutV2/CartQueryCustomFragment";
import {CartProvider} from "@shopify/hydrogen-react";
import {useLocale} from "./localization/useLocale";

const LocalizedShopifyProviderWithCart = ({children}: {children: React.ReactNode}): React.ReactElement => {
  const {locale} = useLocale();

  return <LocalizedShopifyProvider>
    <CartProvider
      countryCode={locale?.countryCode}
      languageCode={locale?.languageCode}
      cartFragment={cartQueryCustomFragment}
    >
      {children}
    </CartProvider>
  </LocalizedShopifyProvider>
}

export default LocalizedShopifyProviderWithCart;
